import React, { useEffect, useState,useRef } from 'react';
import { useParams, usePathname, useRouter } from 'next/navigation';
import { HeaderProvider } from './context';
import { HeaderProps } from './types';
import Typography from '@/components/atoms/typography';
import AlgoliaSearch from '../../atoms/search-algolia/index';
import useAccount from '@/lib/hooks/useAccount';
import useIsCurrentPage from '@/lib/hooks/useIsCurrentPage';
import Menu from '@/components/atoms/menu';
import MenuItem from '@/components/atoms/menu-item';
import HeaderNavigationMobile from './header-navigation-mobile';
// import { CartIcon } from './cart-link';
import { useStoreAndBusinessUnits } from '@/providers/store-and-business-units';
import Button from '@/components/atoms/button';
import useTranslation from '@/providers/I18n/hooks/useTranslation';
import { sdk } from '@/sdk/CommercetoolsSDK';
import toast from '@/components/atoms/toaster/helpers/toast';
import Modal from '../modal';
import Image from '@/components/atoms/Image';
import useMediaQuery from '@/hooks/useMediaQuery';
import { desktop, mediumDesktop } from '@/constants/screensizes';
import InfoTooltip from '@/components/atoms/info-tooltip';
import Link from '@/components/atoms/link';
import HeaderLogo from './header-logo';
import { MagnifyingGlassIcon, XMarkIcon, StarIcon as StarIconSolid  } from '@heroicons/react/24/solid';
import { StarIcon as StarIconOutline } from '@heroicons/react/24/outline';
import NextLink from 'next/link';
import { MagnifyingGlassIcon as SearchIcon, XMarkIcon as CloseIcon } from '@heroicons/react/24/solid';
import { stat } from 'fs';
import { CartIcon } from './cart-link';
import { useCartConfig } from '@/providers/cart-config/CartConfigContext';

const Header = ({
  variant,
  searchPlaceholder,
  searchSuggestions,
  headerSearch,
  categories,
  onHeaderSearch,
  ...props
}: HeaderProps) => {
  const { locale } = useParams();
  const params = useParams();
  const pathname = usePathname();


  const router = useRouter();
  const { cartItems } = props;
  const [isDesktop, minWidth] = useMediaQuery(desktop);
  const [showSearchBar, setShowSearchBar] = useState(true);
  const [showDropDown, setShowDropDown] = useState(true);
  const [showSearchBarDesktop, setShowSearchBarDesktop] = useState(false);
  const [showSearchBarBigDesktop, setShowSearchBarBigDesktop] = useState(true);
  const [showSearchIcon, setShowSearchIcon] = useState(false);
  const isHomePage = pathname === `/${locale}/` || pathname === `/${locale}`;
  const [hasWishlistItems, setHasWishlistItems] = useState(false);
  useEffect(() => {
    if (minWidth < mediumDesktop) {
      setShowSearchBarDesktop(true);
    } else if (minWidth > mediumDesktop) {
      setShowSearchBarDesktop(false);
      setShowSearchIcon(false);
    }
  }, [minWidth]);
  const [focused, setFocused] = useState(false);
  const [query, setQuery] = useState('');
  // const [immediateQuery, setImmediateQuery] = useState('');
  const [subscribe, setSubscribe] = useState(false);
  const [enable, setEnable] = useState(false);
  const [price, setPrice] = useState('');
  const [loading, setLoading] = useState(false);
  const [teamCanToggle, setTeamCanToggle] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAdminView, setIsAdminView] = useState(false);
  const isCurrentPage = useIsCurrentPage(['/au/', '/nz/']);
  const { loggedIn, account, is_blocked, logout } = useAccount();
  const { isCartEnabled } = useCartConfig();
  const status = account?.onboarding_workflow_status === 'MemberRegistered';
  useEffect(() => {
    if (is_blocked) {
      logout().then(() => {
        router.replace(`/`);
      });
    }
  }, [is_blocked, logout, router, locale]);
  // const isRegistrationPage = useIsCurrentPage([
  //   '/au/company-registration/',
  //   '/nz/company-registration/',
  //   '/au/collection-statement/',
  //   '/nz/collection-statement/',
  // ]);
  const isPdp = useIsCurrentPage(['/p/']);

  const checkWishlist = React.useCallback(async () => {
    try {
      const storeKey = locale === 'au' ? 'plumbershub-au' : 'plumbershub-nz';
      const response = await sdk.composableCommerce.custom.getCustomerWishlist({ pageNumber: 1, pageSize: 1,storeKey });
      if (!response.isError && response.data?.data?.items) {
        setHasWishlistItems(response.data.data.items.length > 0);
      }
    } catch {
      // silent — star stays empty
    }
  }, []);

  useEffect(() => {
    checkWishlist();
    const handleWishlistUpdate = () => checkWishlist();
    window.addEventListener('wishlist-updated', handleWishlistUpdate);
    return () => window.removeEventListener('wishlist-updated', handleWishlistUpdate);
  }, [checkWishlist]);
  
  const [isBrochure, setIsBrochure] = useState(false);
  const [hasBackHistory, setHasBackHistory] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setIsBrochure(params.has('b'));
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setHasBackHistory(window.history.length > 1);
    }
  }, []);
  const { selectedBusinessUnit } = useStoreAndBusinessUnits();
  const { translate } = useTranslation();
  const extensions = sdk.composableCommerce;
  const enablePriceToggle = false
const calledRef = useRef(false);

useEffect(() => {
  if (!loggedIn || !account?.accountId || calledRef.current) {
    return;
  }

  const today = new Date().toISOString().split('T')[0];
  const storageKey = `plumbershub-login-${account.accountId}`;
  const lastCalledDate = localStorage.getItem(storageKey);
  // Already called today
  if (lastCalledDate === today) {
    calledRef.current = true;
    return;
  }

  calledRef.current = true;

  const callApi = async () => {
    try {
      const response = await sdk.call({
        actionName: 'account/insertPlumbershubLoginDetailsToQueue',
      });

      if (response.isError) {
        console.error('Failed to call queue API:', response.error);
        calledRef.current = false;
      } else {
        console.log('API Success');
        localStorage.setItem(storageKey, today);
      }
    } catch (error) {
      console.error('Failed to call queue API:', error);
      calledRef.current = false;
    }
  };

  callApi();
}, [loggedIn, account?.accountId]);
  const NavItem: any = ({ item, onOpen, onClose, isExpanded }: any) => {
    const handleClick = () => {
      if (showDropDown) {
        onOpen();
      } else {
        onClose();
      }
      setShowDropDown((prevState) => !prevState);
    };

    return (
      // <Link href={item.href ?? '#'}>
      <div

        onClick={() => onOpen()}

        className="group flex h-[4rem] cursor-pointer items-center gap-1"
      >
        <Typography
          className="text-black-800 grow whitespace-nowrap text-[16px] leading-[20px] font-semibold"
        >
          {item?.name}
        </Typography>
        <svg
          className={`${isExpanded && 'rotate-180'} transition-transform`}
          width="18"
          height="19"
          viewBox="0 0 18 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.2863 6.35547L9.00056 12.6412L2.71484 6.35547"
            stroke="#666666"
            strokeWidth="1.57143"
            strokeLinecap="square"
          />
        </svg>
      </div>
      // </Link>
    );
  };

  const isMegaMenuItems = props.pageLinks
    ?.filter((item: any) => item?.subMenu && item?.subMenu?.length > 1)
    .map((item) => item.name);



  return (
    <HeaderProvider {...props}>
      <>
        {loggedIn && status && (
          <header className="hidden lg:block shadow-sm bg-white">
            <div className={`relative flex items-center justify-between px-4 md:px-5 lg:px-10 max-w-[1920px] mx-auto`}>
              <div className="flex items-center  gap-x-8 lg:gap-x-4 xl:gap-x-6 2xl:gap-x-8">
                <Link link={'/'} preFetch={true}>
                  <div className='text-16 mt-[14px] cursor-pointer' >
                    <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.70711 0.765549C8.31658 0.375025 7.68342 0.375025 7.29289 0.765549L0.292893 7.76555C-0.0976311 8.15607 -0.0976311 8.78924 0.292893 9.17976C0.683417 9.57029 1.31658 9.57029 1.70711 9.17976L2 8.88687V15.4727C2 16.0249 2.44772 16.4727 3 16.4727H5C5.55228 16.4727 6 16.0249 6 15.4727V13.4727C6 12.9204 6.44772 12.4727 7 12.4727H9C9.55229 12.4727 10 12.9204 10 13.4727V15.4727C10 16.0249 10.4477 16.4727 11 16.4727H13C13.5523 16.4727 14 16.0249 14 15.4727V8.88687L14.2929 9.17976C14.6834 9.57029 15.3166 9.57029 15.7071 9.17976C16.0976 8.78924 16.0976 8.15607 15.7071 7.76555L8.70711 0.765549Z" fill="#090909" />
                    </svg>
                  </div>
                </Link>

                {props.pageLinks?.map((menuItem: any, index) => {
                  if (isMegaMenuItems?.includes(menuItem?.name)) {
                    return (
                      <React.Fragment key={index}>
                        <Menu
                          header={false}
                          data={menuItem}
                          Element={NavItem}
                          rootClassname="w-full relative"
                          classnames={
                            'absolute main_menu_container top-[4rem] flex items-start justify-between gap-8 bg-[#F8F8F8] w-screen max-w-screen-md h-auto p-8 shadow-sm'
                          }
                        >
                          {menuItem?.subMenu?.map((subItem: any, index: number) => {
                            const isBySegment = subItem?.title === 'By Segment';

                            return (
                              <div key={index} className="h-full w-full">
                                <div className="flex ">
                                  <Typography className="!mb-3 w-2/4 text-left text-16 !font-[600] !leading-[19px] text-[#333333]">
                                    {subItem?.title}
                                  </Typography>
                                  {isBySegment && (
                                    <Button
                                      size="s"
                                      className=" relative top-[-6px] h-[28px] w-2/4 !rounded-full !bg-[#FF0000] !px-1 !pt-1.5 !text-12 "
                                    >
                                      {translate('common.coming.soon.button')}{' '}
                                    </Button>
                                  )}
                                </div>
                                <div className="hide-bar  max-h-[18rem]">
                                  {subItem?.mega_menu?.map((_it: any, idx: number) => {
                                    return (
                                      <React.Fragment key={idx}>
                                        <MenuItem
                                          classnames={`bg-[#F8F8F8] w-full text-white mx-auto p-[3px] border-b border-[#EEEEEE] cursor-pointer`}
                                        >
                                          <Link link={`/${locale}${_it?.mega_menu_url?.href}`}>
                                            <Typography className="text-left text-[16px] !font-[500] !leading-[19px] text-[#333333]">
                                              {_it?.mega_menu_url?.title}
                                            </Typography>
                                          </Link>
                                        </MenuItem>
                                      </React.Fragment>
                                    );
                                  })}
                                </div>
                              </div>
                            );
                          })}
                        </Menu>
                      </React.Fragment>
                    );
                  } else if (!isMegaMenuItems?.includes(menuItem?.name)) {
                    return (
                      <div key={index} className="">
                        <Menu
                          header={false}
                          data={menuItem}
                          Element={NavItem}
                          rootClassname="w-full relative"
                          classnames={'absolute left-0 top-[3.75rem]'}
                        >
                          {menuItem?.subMenu[0]?.mega_menu?.map((subItem: any, index: any) => {
                            const hasHref = subItem?.mega_menu_url?.href?.length > 0;
                            const isAbsoluteUrl = subItem?.mega_menu_url?.href.startsWith('http');
                            const linkHref = isAbsoluteUrl
                              ? subItem?.mega_menu_url?.href
                              : `/${locale}${subItem?.mega_menu_url?.href}`;

                            return (
                              (subItem?.mega_menu_url?.title !== 'Product Pricelist') && (
                                <MenuItem
                                  classnames={`main_menu_container text-[16px] bg-[#F8F8F8] w-[230px] text-white mx-auto p-[10px] border-b border-[#EEEEEE] cursor-pointer`}
                                  key={index}
                                >
                                  {!hasHref ? (
                                    <Typography className="text-left text-[16px] !font-[500] !leading-[19px] text-[#333333]">
                                      {subItem?.mega_menu_url?.title}
                                    </Typography>
                                  ) : (
                                    <Link
                                      link={`${linkHref}`}
                                      target={isAbsoluteUrl ? '_blank' : undefined}
                                      prefetch={false}
                                    >
                                      <Typography className="text-left text-[16px] !font-[500] !leading-[19px] text-[#333333]">
                                        {subItem?.mega_menu_url?.title}
                                      </Typography>
                                    </Link>
                                  )}
                                </MenuItem>
                              )
                            );
                          })}
                        </Menu>
                      </div>
                    );
                  }
                  return null;
                })}
              </div>

              <div className="flex flex-wrap items-center justify-between gap-6 lg:gap-2 xl:gap-6  xl:pl-0  ">
                {variant === 'navigation' && (
                  <div id="searchIconHeader" className="hidden lg:block xl:w-[380px]">
                    {showSearchBarDesktop ? (
                      <div className="w-fit cursor-pointer">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                          fill="none"
                          onClick={() => setShowSearchIcon(!showSearchIcon)}
                        >
                          <path
                            onClick={() => setShowSearchIcon(!showSearchIcon)}
                            d="M22.75 22.75L16.25 16.25M18.4167 10.8333C18.4167 15.0215 15.0215 18.4167 10.8333 18.4167C6.64517 18.4167 3.25 15.0215 3.25 10.8333C3.25 6.64517 6.64517 3.25 10.8333 3.25C15.0215 3.25 18.4167 6.64517 18.4167 10.8333Z"
                            stroke="#666666"
                            strokeWidth="2"
                            strokeLinecap="square"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    ) : (
                      showSearchBarBigDesktop && (
                        <div className={`relative bg-white  ${focused ? 'z-[1005]' : 'z-[1000]'}`}>
                          <AlgoliaSearch
                            categories={categories}
                            setShowSearchBar={setShowSearchBar}
                            focused={focused}
                            setFocused={setFocused}
                            query={query}
                            setQuery={setQuery}
                            // immediateQuery={immediateQuery}
                            // setImmediateQuery={setImmediateQuery}
                            typoTolerance={false}
                          />
                          {/* <MagnifyingGlassIcon
          className="stroke-10  absolute left-[1rem] top-1/2 z-[999] h-24 w-24 -translate-y-1/2 text-[#666] lg:hidden"
          onClick={() => setShowSearchBar(false)}
        /> */}
                        </div>
                      )
                    )}
                  </div>
                )}
                
                {isCartEnabled && (
                  <CartIcon
                    className={`relative flex cursor-pointer items-center gap-2`}
                    cartItems={cartItems}
                    // cartItems={4}
                    onClick={() => router.push(`/${locale}/cart`)}
                  />
                )}
                <NextLink href="/wishlist/" aria-label="ducts">
                  {hasWishlistItems
                    ? <StarIconSolid className="h-6 w-6 text-gray-800 cursor-pointer hover:text-gray-900 transition-colors" />
                    : <StarIconOutline className="h-6 w-6 text-gray-600 cursor-pointer hover:text-gray-800 transition-colors" />
                  }
                </NextLink>
              </div>
            </div>
            {showSearchIcon && showSearchBarDesktop && (
              <div className={`relative bg-white  ${focused ? 'z-[1005]' : 'z-[1000]'} w-full lg:px-10 mb-5 `}>
                <div className="relative z-[5] !rounded-[4px] w-full  mx-auto">
                  <div className="text-primary-black absolute right-[1rem] top-4 z-[12] !h-[24px] !w-[24px] -translate-y-1/2 bg-white stroke-2 hover:cursor-pointer lg:right-[0.9rem] xl:right-[1rem] ">
                    <XMarkIcon className="h-6 w-6 text-neutral-600" onClick={() => {
                      setShowSearchIcon(false)
                      setShowSearchBarDesktop(true)
                    }} />
                  </div>

                  <AlgoliaSearch
                    categories={categories}
                    setShowSearchBar={setShowSearchBar}
                    focused={focused}
                    setFocused={setFocused}
                    query={query}
                    // immediateQuery={immediateQuery}
                    // setImmediateQuery={setImmediateQuery}
                    setQuery={setQuery}
                    typoTolerance={false}
                  />


                </div>

                <MagnifyingGlassIcon
                  className="stroke-10  absolute left-[1rem] top-4 z-[999] h-[21px] w-[21px] -translate-y-1/2 text-[#666] lg:hidden"
                  onClick={() => setShowSearchBar(false)}
                />
              </div>
            )}



          </header>
        )}
        {/* Mobile bar */}
        <header className="block lg:hidden shadow-sm bg-white">
          <div className="flex h-[64px] !flex-nowrap items-center justify-between gap-3 px-4 md:px-8 lg:px-10 max-w-[1920px] mx-auto">
            <HeaderLogo logo={props.logo} logoLink={status ? (props.logoLink.href || '/') : '/'} imageClassName="flex h-[100px] w-[236px] text-16 font-bold" />
            <div className="my-auto flex items-center gap-x-6 self-center lg:block">
              {status && (
                <HeaderNavigationMobile
                  logo={props.logo}
                  links={props.mobileLinks}
                  logoLink={props.logoLink}
                  showSearchBar={showSearchBar}
                  setShowSearchBar={setShowSearchBar}
                  selectedBusinessUnit={props.selectedBusinessUnit}
                  businessUnits={props.businessUnits}
                  onBusinessUnitChange={props.onBusinessUnitChange}
                  isAdmin={props.isAdmin}
                />
              )}
            </div>
          </div>
          {status && showSearchBar && (
            <div className="relative z-[1000] w-full bg-white px-4 pt-0 pb-2 flex items-center gap-4">
              {
                !isHomePage && hasBackHistory && <div className="cursor-pointer" onClick={() => {
                  if (pathname?.includes('order-confirmed')) {
                    router.push('/');
                  } else {
                    router.back();
                  }
                }}>
                  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="15" cy="15" r="15" fill="#F3EDE9" />
                    <path d="M13.3333 20.8333L7.5 15M7.5 15L13.3333 9.16666M7.5 15L22.5 15" stroke="#090909" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              }

              <div className={`relative flex-1 ${focused ? 'z-[1005]' : 'z-[1000]'}`}>
                <AlgoliaSearch
                  categories={categories}
                  setShowSearchBar={setShowSearchBar}
                  focused={focused}
                  setFocused={setFocused}
                  query={query}
                  setQuery={setQuery}
                  typoTolerance={false}
                />
              </div>

              <NextLink href="/wishlist/" aria-label="Saved Products">
                {hasWishlistItems
                  ? <StarIconSolid className="h-6 w-6 text-gray-800 cursor-pointer hover:text-gray-900 transition-colors" />
                  : <StarIconOutline className="h-6 w-6 text-gray-600 cursor-pointer hover:text-gray-800 transition-colors" />
                }
              </NextLink>
            </div>
          )}
        </header>
        <div>
          <Modal
            className="flex flex-col items-center justify-center !p-10"
            isOpen={isModalOpen}
            onRequestClose={() => setIsModalOpen(false)}
            preventScroll={false}
            closeButton={true}
            size="sm"
            variant="default"
            centered={true}
          >
            <>
              <Image src="/images/Caroma_Trade_Logo (2).png" width={400} height={97} alt="empty cart image" />
              <Typography className="mt-2 px-4 text-center text-16 !font-medium text-black">
                {translate('common.priceMessage')}
              </Typography>
              <div className="flex gap-8">
                <>
                  <Button
                    size="custom"
                    variant="secondary"
                    type="submit"
                    className="mt-10 w-[120px] bg-white !py-3 px-6 !font-semibold text-black"
                    onClick={() => {
                      setIsModalOpen(false);
                      // updatePrice(true, price);
                    }}
                  >
                    {translate('common.confirm')}
                  </Button>
                  <Button
                    size="custom"
                    variant="secondary"
                    type="submit"
                    className="mt-10 w-[120px] bg-[#2B2C39] !py-3 px-6 text-white"
                    onClick={() => {
                      setIsModalOpen(false);
                    }}
                  >
                    {translate('common.cancel')}
                  </Button>
                </>
              </div>
            </>
          </Modal>
        </div>
      </>

    </HeaderProvider>
  );
};
export default Header;
